import { lazy, Suspense } from 'react';

import { AREA_BASE_PATHS, DEFAULT_ROUTE, PortalArea } from 'portalPaths';

const DesignerApp = lazy(() => import('./apps/designer/App'));
const AnalyticsApp = lazy(() => import('./apps/analytics/App'));
const AdminApp = lazy(() => import('./apps/admin/App'));

function resolveArea(pathname: string): PortalArea | null {
    const normalizedPath = pathname.toLowerCase().replace(/\/+$/, '');

    for (const [area, basePath] of Object.entries(AREA_BASE_PATHS) as [PortalArea, string][]) {
        if (normalizedPath === basePath || normalizedPath.startsWith(`${basePath}/`)) {
            return area;
        }
    }

    return null;
}

function App() {
    const area = resolveArea(window.location.pathname);

    if (!area) {
        window.location.replace(DEFAULT_ROUTE);
        return null;
    }

    return (
        <Suspense fallback={<div className="portal-loading">Loading ReCX…</div>}>
            {area === 'designer' && <DesignerApp />}
            {area === 'analytics' && <AnalyticsApp />}
            {area === 'admin' && <AdminApp />}
        </Suspense>
    );
}

export default App;
